import RestX from '~/RestX';
import UniversityService from './UniversityService';

class ResourceService {
    static getResources() {
        return UniversityService.getCurrentSchoolData().then(data => {
            if (data.id) {
                return RestX.getInterfaces()
                    .resources.nodes.get()
                    .then(res => {
                        return res.data.filter(
                            r =>
                                r.organizations.includes(data.id.toString()) &&
                                r.public
                        );
                    })
                    .catch(err => {
                        console.log(err);
                        Promise.resolve([]);
                    });
            } else {
                return Promise.resolve([]);
            }
        });
    }

    static hasResources() {
        return this.getResources().then(result => {
            return result.filter(r => r.parent).length > 0;
        });
    }
}

export default ResourceService;
